import '../styles/SlideshowEditor.css';
import { useEffect, useMemo, useState, useCallback } from 'react';
import { isAuthorOf, isOwnerOf } from '../utils/commonUtils';
import SlideshowEditorTab from './SlideshowEditorTab';
import ModalDelete from './ModalDelete';
import { useGet, useRest } from 'react-common';
import SlidePreview from './SlidePreview';
import SlideForm from './SlideForm';
import SlideshowEditModal from './SlideshowEditModal';


const SlideshowEditor = () => {

    const [activeSlideshowID, setActiveSlideshowID] = useState('');
    const [activeSlideID, setActiveSlideID] = useState('');
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
    const [type, setType] = useState(null);
    const [slideConfiguration, setSlideConfiguration] = useState({});
    const { deleteData, getData } = useRest();
    const [isOpenSlideshowEdit, setIsOpenSlideshowEdit] = useState(false);
    const [slides, setSlides] = useState();
    const [slideshowDelete, setSlideshowDelete] = useState(false);
    const [testResponses ,setTestResponses] = useState(null);

    const [slideshows = [], /*slideshowsLoading*/, refreshSlideshows] = useGet("Slideshows", {
        transform: (res) => {
            return res.records || [];
        }
    });
    
    const getSlides = useCallback(() => {
        getData("Slides", {slideshowID: activeSlideshowID})
            .then((result) => {
                setSlides(result.records?.map(s => ({ ...s, title: 'Slide ' + s.index })))
            })
            .catch(err => {
                console.log(err)
            })
    }, [getData, activeSlideshowID])

    const activeSlideshow = useMemo(() => {
        return slideshows.find(s => s.id === activeSlideshowID)
    }, [activeSlideshowID, slideshows]);

    const activeSlide = useMemo(() => {
        if(slides){
            return slides.find(s => s.id === activeSlideID)    
        } 
    }, [activeSlideID, slides]);

    const canModify = useMemo(() => {
        if(!activeSlideshow){
            return false;
        } else {
            return (isOwnerOf(activeSlideshow) || isAuthorOf(activeSlideshow)); 
        }
    }, [activeSlideshow])

    const isOwner = useMemo(() => {
        if(!activeSlideshow){
            return false;
        } else {
            return isOwnerOf(activeSlideshow)
        }     
    }, [activeSlideshow])

    const deleteSlide = () => {
        deleteData( 'Slide/' + activeSlideID)
        .then(() => {
            setIsOpenDeleteModal(false);
            getSlides();
        })
        .catch((e) => {
            console.log(e);
        });
    }

    const deleteSlideshow = () => {
        deleteData('Slideshow/' + activeSlideshowID)
        .then(() => {
            setIsOpenDeleteModal(false)
            refreshSlideshows()
            setActiveSlideshowID(null)
            setActiveSlideID(null)
            getSlides()
            setSlideshowDelete(false)
        })
        .catch((e) => {
            console.log(e);
        });
    }

    useEffect(() => {
        if(activeSlideshowID){
            getSlides()   
        }
    }, [activeSlideshowID, getSlides])

    useEffect(() => {
        if(activeSlide){
            setSlideConfiguration(activeSlide.configuration); 
            setType(activeSlide.type) 
            setTestResponses(null)
        }
    }, [activeSlide])

    return (
        <div className="slideshowEditorContainer">
            <div className="slideshowEditorTabContainer">
                <SlideshowEditorTab 
                    activeSlideshowID={activeSlideshowID}  
                    setActiveSlideshowID={setActiveSlideshowID}  
                    slideshows={slideshows}  
                    canModify={canModify}
                    slides={slides} 
                    activeSlideID={activeSlideID} 
                    setActiveSlideID={setActiveSlideID}
                    setIsOpenDeleteModal={setIsOpenDeleteModal}
                    refreshSlideshows={refreshSlideshows}
                    activeSlideshow={activeSlideshow}
                    setIsOpenSlideshowEdit={setIsOpenSlideshowEdit}
                    getSlides={getSlides}
                    setSlideshowDelete={setSlideshowDelete}
                />    
            </div>
              
            {activeSlide && 
                <>
                    <div className="slidePreviewContainer">
                        <SlidePreview  
                            type={type}
                            slideConfiguration={slideConfiguration}
                            results={testResponses}
                        />    
                    </div>
                    
                    {canModify &&
                        <div className="slideFormContainer">
                            <SlideForm 
                                slide={activeSlide}
                                slideConfiguration={slideConfiguration} 
                                setSlideConfiguration={setSlideConfiguration} 
                                type={type}
                                setType={setType}
                                setTestResponses={setTestResponses}
                            />    
                        </div>
                    }
                </>    
            }  
            {isOpenSlideshowEdit && (
                <SlideshowEditModal
                    isOpenSlideshowEdit={isOpenSlideshowEdit} 
                    setIsOpenSlideshowEdit={setIsOpenSlideshowEdit} 
                    slideshow={activeSlideshow}
                    isOwner={isOwner}
                />
            )}

            {isOpenDeleteModal && 
                <ModalDelete 
                    isOpenDeleteModal={isOpenDeleteModal} 
                    setIsOpenDeleteModal={setIsOpenDeleteModal} 
                    deleteFunction={slideshowDelete ? deleteSlideshow : deleteSlide}
                />
            }
        </div>    
    )
}

export default SlideshowEditor;